import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level5Illustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4110" data-mp="ntx0bxy82ceu">
      
      <div className="relative w-full h-full bg-gradient-to-b from-green-200 to-emerald-400 overflow-hidden" data-id="element-4111" data-mp="12mqsaiuokl0e">
        {/* Background: Garden/Nature */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4112" data-mp="1bkjaburse6rh">
          
          {/* Bushes */}
          <circle cx="30" cy="140" r="40" fill="#22C55E" data-id="element-4113" data-mp="3dcp9ilbj1bos" />
          <circle cx="60" cy="150" r="35" fill="#16A34A" data-id="element-4114" data-mp="3dd7gabvtf8ay" />
          <circle cx="170" cy="130" r="45" fill="#22C55E" data-id="element-4115" data-mp="38enss71kpogh" />
          <circle cx="140" cy="150" r="30" fill="#16A34A" data-id="element-4116" data-mp="38g8lrs88ozc8" />

          {/* Sun */}
          <circle cx="160" cy="40" r="25" fill="#FEF08A" data-id="element-4117" data-mp="3fkp3gnauu966" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-4118" data-mp="3ki8ihpfdmpz6">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-4119" data-mp="3pfh27ug6b22j">
            <DjaySpecimen look={{
            variant,
            accessory: 'leafGarland'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4120" data-mp="3u8tpo19492tp" />
            
          </div>
        </div>

        {/* Foreground: Leaves and Flowers */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4121" data-mp="c2ovh85au3sk">
          
            {/* Floating leaves */}
            <path d="M40 60 Q50 50 60 60 Q50 70 40 60 Z" fill="#86EFAC" transform="rotate(15 50 60)" data-id="element-4122" data-mp="2dvcz3iluut8v" />
          
            <path d="M140 80 Q150 70 160 80 Q150 90 140 80 Z" fill="#4ADE80" transform="rotate(-25 150 80)" data-id="element-4123" data-mp="2iuply3cq80bg" />
          
            <path d="M20 100 Q30 90 40 100 Q30 110 20 100 Z" fill="#86EFAC" transform="rotate(45 30 100)" data-id="element-4124" data-mp="25suam0eebt85" />
          

            {/* Flowers */}
            <g transform="translate(30, 160) scale(0.5)" data-id="element-4125" data-mp="2kquyq89190rq">
              <circle cx="0" cy="-10" r="8" fill="#F472B6" data-id="element-4126" data-mp="2fr9zdwpyaqeh" />
              <circle cx="10" cy="0" r="8" fill="#F472B6" data-id="element-4127" data-mp="2fpp8ch2uhpld" />
              <circle cx="0" cy="10" r="8" fill="#F472B6" data-id="element-4128" data-mp="2tq00rojszc8n" />
              <circle cx="-10" cy="0" r="8" fill="#F472B6" data-id="element-4129" data-mp="2oronf3uaujlo" />
              <circle cx="0" cy="0" r="6" fill="#FDE047" data-id="element-4130" data-mp="2or5g0h29zdlw" />
            </g>

            <g transform="translate(170, 170) scale(0.6)" data-id="element-4131" data-mp="33guneu0yodum">
              <circle cx="0" cy="-10" r="8" fill="#60A5FA" data-id="element-4132" data-mp="33ifiqlv3o0tj" />
              <circle cx="10" cy="0" r="8" fill="#60A5FA" data-id="element-4133" data-mp="2yi047qz30n9z" />
              <circle cx="0" cy="10" r="8" fill="#60A5FA" data-id="element-4134" data-mp="3cgre116wvmsb" />
              <circle cx="-10" cy="0" r="8" fill="#60A5FA" data-id="element-4135" data-mp="3cf6k9dsf87vi" />
              <circle cx="0" cy="0" r="6" fill="#FDE047" data-id="element-4136" data-mp="38gpa0ldpeh9v" />
            </g>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}